export default __webpack_public_path__ + "static/media/kast-kontor.54bcb628.jpg";